'use strict';var _dec,_desc,_value,_class;function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const BaseController=require('../../../../../dist-es6/client/angularCommon/baseController');
const treeUtils=require('pulsar-utils/dist-es6/treeUtils');
const HandleUncaughtErrors=require('../../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;
const ModalSubmissionResult=require('../../../../../dist-es6/client/angularCommon/modalSubmissionResult');
const SocketResponse=require('../../../../../dist-es6/client/dtos/socketResponse');let

CreateGroupModalController=(_dec=






























HandleUncaughtErrors(ModalSubmissionResult.FromError),(_class=class CreateGroupModalController extends BaseController{static get $inject(){return['$modalInstance','$state','groupsCommandAndQueryService','uiCommandFactory','groupTree','onGroupCreated','uncaughtErrorHandler','socketService']}constructor($modalInstance,$state,groupsCommandAndQueryService,uiCommandFactory,groupTree,onGroupCreated,uncaughtErrorHandler,socketService){super(uncaughtErrorHandler);this._$modalInstance=$modalInstance;this._$state=$state;this._socketService=socketService;this._onGroupCreated=onGroupCreated;this._allGroupsFlattened=[...treeUtils.flatten(groupTree)];this._createGroupCommand=uiCommandFactory.makeForModal($modalInstance,()=>this._createGroup());this._initializeFormValues()}_initializeFormValues(){this.parent=_.exists(this.allGroupsFlattened[0])?this.allGroupsFlattened[0]:null;this.isSubgroup=!1}get allGroupsFlattened(){return this._allGroupsFlattened}get createGroupCommand(){return this._createGroupCommand}
async _createGroup(){
let response=await this._socketService.sendAndWaitForResponse('CreateGroup',{
name:this.groupName,
parentId:this.isSubgroup&&_.exists(this.parent.id)?this.parent.id:null});

if(SocketResponse.succeeded(response)){
await this._onGroupCreated(response.body.id);

return ModalSubmissionResult.Close();
}


return ModalSubmissionResult.KeepOpen;
}

onCancel(){
this._$modalInstance.dismiss();
}},(_applyDecoratedDescriptor(_class.prototype,'_createGroup',[_dec],Object.getOwnPropertyDescriptor(_class.prototype,'_createGroup'),_class.prototype)),_class));


module.exports=CreateGroupModalController;
//# sourceMappingURL=createGroupModalController.js.map
